import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    ElevatedCard,
    Stack,
    Subtitle1,
} from '@myphx-engineering/phx-design-system';

import configs from '../../../../configuration/lilly-direct';

export const TheresMoreCard = () => {
    const { t } = useTranslation('lilly');
    const { constants } = configs;

    return (
        <ElevatedCard>
            <Stack gap="sm">
                <Subtitle1>{t('orderConfirmation.card.header')}</Subtitle1>
                <Body1>{t('orderConfirmation.card.body')}</Body1>
                <Button
                    onClick={() =>
                        window.open(constants.LILLY_DIRECT_URL, '_blank')
                    }
                >
                    {t('orderConfirmation.card.button')}
                </Button>
            </Stack>
        </ElevatedCard>
    );
};
